export default {
  FILTER_CYCLE_LIST: 'FilterCycleList',
  SORT_CYCLE_LIST: 'SortCycleList',
  LOAD_CYCLE_LIST_START: 'LoadCycleListStart',
  LOAD_CYCLE_LIST_END: 'LoadCycleListEnd',
  SEARCH_CYCLE_LIST_FILTER_STUDY_PROGRAM_START: 'SearchCycleListFilterStudyProgramStart',
  SEARCH_CYCLE_LIST_FILTER_STUDY_PROGRAM_END: 'SearchCycleListFilterStudyProgramEnd',
  TOGGLE_CYCLE_LIST_CONFIRM_DIALOG: 'ToggleCycleListConfirmDialog'
};